/* import __COLOCATED_TEMPLATE__ from './tester-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class TesterCardComponent extends Component 
{
	@tracked errReads = [];
	@tracked chipReads = [];
	
	@service socketGuru;
	@service gochipsAjax;
	@service ajax;
	@service store;
		
	constructor()
	{
		super(...arguments);
		this._boundHandleSocketEvent = this._handleSocketEvent.bind(this);
		this.socketGuru.events.addEventListener('newEvent', this._boundHandleSocketEvent);

    }

	@action
	async buildInitalChipList()
	{
		var translations = await this.store.findAll("Translation");
		translations = [...translations];
		const newChips = translations.map(t => ({
			id: t.name,
			chipId: t.chip,
			read: false,
			voltage: null,
			lowVolt: null,
			highVolt: null,
			avgVolt: null
		}));
		this.chipReads = [...this.chipReads, ...newChips];
	}

    willDestroy()
	{
		this.socketGuru.events.removeEventListener('newEvent', this._boundHandleSocketEvent);
		super.willDestroy();
    }
	
    _handleSocketEvent(event)
	{
		const { eventName, data: eventData } = event.detail;
		if(eventName == "stdErr")
		{
			let data = JSON.parse(eventData);

			var message = String.fromCharCode.apply(null, data.message.data)
			if(message == "Translation Not Found")
			{
				this.errReads = [...this.errReads, {id:data.bib}];
			}
		}
		if(eventName == "stdOut")
		{
			let data = JSON.parse(eventData);

			var found = false;
			// Create new objects for reactivity - mutating existing objects doesn't trigger Glimmer updates
			this.chipReads = this.chipReads.map(chip => {
				if(String(chip.chipId) === String(data.chip))
				{
					found = true;
					return { ...chip, read: true };
				}
				return chip;
			});

			if(!found)
			{
				this.chipReads = [...this.chipReads, {
					id: data.chip,
					chipId: data.chip,
					read: true,
					voltage: null,
					lowVolt: null,
					highVolt: null,
					avgVolt: null
				}];
			}
		}
    }
	
	@action
	async checkChipVoltages()
	{
		for(var chip of this.chipReads)
		{
			if(chip.read && chip.chipId != "")
			{
				var chipStats = await this.gochipsAjax.request('/chipStatus/'+chip.chipId);
				chip.voltage = Number.parseFloat(chipStats.voltage).toFixed(2);
				chip.lowVolt = Number.parseFloat(chipStats.lowestWeekVoltage).toFixed(2);
				chip.highVolt = Number.parseFloat(chipStats.highestWeekVoltage).toFixed(2);
				chip.avgVolt = Number.parseFloat(chipStats.averageWeekVoltage).toFixed(2);
			}
		}
		// Trigger reactivity by reassigning
		this.chipReads = [...this.chipReads];
	}
}
		